/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-logement-true': {
    width: 65,
    height: 65,
    viewBox: '0 0 65 65',
    data: '<path pid="0" class="st0" d="M63 21L34.7.8C34 .2 33.2 0 32.4 0c-.8 0-1.6.2-2.4.8L1.7 21c-.4.3-.7.6-.9.9-.8 1-1 2.4-.6 3.6.4 1.3 1.4 2.2 2.6 2.6.4.1.8.2 1.3.2h4v32.4c0 2.2 1.8 4 4 4H52.5c2.2 0 4-1.8 4-4V28.3h4c1.3 0 2.5-.6 3.3-1.7.2-.3.4-.7.6-1.1.1-.4.2-.8.2-1.3.1-1.2-.5-2.5-1.6-3.2m-10.4 3.3V60.7H12.2V24.3H4L32.4 4l28.3 20.2h-8.1z"/>'
  }
})
